import App from "@/App.tsx";
import { NotVerified } from "@/pages/auth/NotVerified.tsx";
import useUserStore from "@/store/user.store.ts";
import { Box } from "@mantine/core";
import { Outlet } from "react-router";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import classes from "@/layouts/app/AppLayout.module.css";

export default function AppLayout() {
  const { user } = useUserStore();

  return (
    <App>
      <Header />
      <Box className={classes.main} p="md">
        {user?.email_verified_at ? <Outlet /> : <NotVerified />}
      </Box>
      <Footer />
    </App>
  );
}
